<template>
  <v-container my-5>
    <p class="display-1 text-xs-center mb-3">Please launch Brainingcamp from your Classlink launchpad.</p>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>

